export default __webpack_public_path__ + "static/blob-08-3bdab3860385c70722c48f4775813aeb.svg";